<template>
  <el-dialog
    v-loading="loading"
    :visible.sync="visible"
    :append-to-body="true"
    title="افزودن دستگاه"
    width="400px"
  >
    <el-form @submit.native.prevent="submit">
      <el-row :gutter="10">
        <el-col :sm="24" class="mb-3">
          <label class="font-9 required">کد IMEI</label>
          <el-input
            ref="imei"
            v-model="form.imei"
            v-validate="'required'"
            v-focus
            v-number.numeric="true"
            data-vv-as="کد IMEI"
            placeholder="کد IMEI"
          />
        </el-col>
      </el-row>
      <div class="text-center" style="margin:20px 0 -10px">
        <el-button type="primary" native-type="submit" :loading="addLoading">
          ثبت
        </el-button>
        <el-button
          :disabled="addLoading"
          @click=";(visible = false), (form.imei = '')"
        >
          انصراف
        </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import MutationCreate from '@/graphql/device/Create.gql'

export default {
  name: 'AddDeviceForm',
  props: {
    editingId: { type: [String, Number], default: '' },
    editingItem: { type: Object, default: null },
    show: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      addLoading: false,
      form: {
        imei: ''
      }
    }
  },
  computed: {
    editing() {
      if (this.editingId) return this.editingId
      if (this.editingItem) return this.editingItem.id
      return false
    },
    visible: {
      get() {
        return this.show
      },
      set(val) {
        if (!val) this.resetForm = ''
        return this.$emit('update:show', !!val)
      }
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.$nextTick(() => {})
      } else {
        this.$emit('update:editingId', null)
        this.$emit('update:editingItem', null)
      }
    },
    editing: {
      immediate: false,
      handler(val) {
        if (val) {
          this.visible = true
        }
      }
    }
  },
  methods: {
    submit() {
      this.$validate().then(() => {
        let data = this.$clone(this.form)
        this.apollo
          .mutate({
            query: MutationCreate,
            variables: data,
            $loadingKey: 'addLoading'
          })
          .then(response => {
            let item = response.data.result
            this.$message.success('اطلاعات با موفقیت ثبت شد')
            this.visible = false
            this.form.imei = ''
            this.$emit('updateTable')
            this.$emit('showEdit', item.id)
          })
      })
    },
    resetForm() {
      for (let key in this.form) {
        if (Object.hasOwnProperty(key)) {
          this.form[key] = ''
        }
      }
    }
  }
}
</script>
